import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _css from "@emotion/css";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
var gridSize = gridSizeFn();
export var Container = function Container(props) {
  return ___EmotionJSX("div", props);
};
export var HeaderContainer = function HeaderContainer(props) {
  var styles = props.styles,
      rest = _objectWithoutProperties(props, ["styles"]);

  return ___EmotionJSX("div", _extends({
    css:
    /*#__PURE__*/
    _css(_objectSpread({}, styles, {
      paddingTop: gridSize * 2.5,
      paddingBottom: gridSize * 2.5
    }), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByZXNlbnRhdGlvbmFsL1NrZWxldG9uQ29udGFpbmVyVmlldy9wcmltaXRpdmVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdNIiwiZmlsZSI6Ii4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByZXNlbnRhdGlvbmFsL1NrZWxldG9uQ29udGFpbmVyVmlldy9wcmltaXRpdmVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGdyaWRTaXplIGFzIGdyaWRTaXplRm4gfSBmcm9tICdAYXRsYXNraXQvdGhlbWUvY29uc3RhbnRzJztcblxuY29uc3QgZ3JpZFNpemUgPSBncmlkU2l6ZUZuKCk7XG5cbmV4cG9ydCBjb25zdCBDb250YWluZXIgPSBwcm9wcyA9PiA8ZGl2IHsuLi5wcm9wc30gLz47XG5cbmV4cG9ydCBjb25zdCBIZWFkZXJDb250YWluZXIgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgc3R5bGVzLCAuLi5yZXN0IH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e3tcbiAgICAgICAgLi4uc3R5bGVzLFxuICAgICAgICBwYWRkaW5nVG9wOiBncmlkU2l6ZSAqIDIuNSxcbiAgICAgICAgcGFkZGluZ0JvdHRvbTogZ3JpZFNpemUgKiAyLjUsXG4gICAgICB9fVxuICAgICAgey4uLnJlc3R9XG4gICAgLz5cbiAgKTtcbn07XG4iXX0= */")
  }, rest));
};